import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachReportPackageReportFolder from './attachReportPackageReportFolder';
import controller from './edit-report-package-dialog.controller';
import template from './edit-report-package-dialog.html';


class dialogService {
  getOptions($event, { reportPackage }) {
    return {
      controller,
      controllerAs: 'editReportPackageDialogVM',
      locals: {
        reportPackage
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.packageReports.editReportPackageDialog', [
  alerts,
  amDataService,
  attachReportPackageReportFolder,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .service('editReportPackageDialog', dialogService)
  .name;
